module.exports = __webpack_public_path__ + "img/balchik.aa669c42.png";